<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    // const web = ['/home', '/about', '/news', '/education', '/product', '/scheme', '/partner']
    // let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    // var isMobile = false
    // if (flag !== null && flag.length > 0) {
    //   isMobile = true
    // } else {
    //   isMobile = false
    // }
    // if (isMobile) {
    //   this.$router.replace('/mindex')
    // } else {
    //   this.$router.replace('/home')
    // }
  },
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}
body {
  margin: 0;
  padding: 0;
  height: 100%;
  min-width: 960px;
}
p {
  margin: 0;
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue